export default __webpack_public_path__ + "static/media/flag-azerbaijan.da5e854b.svg";